import { useQuery } from '@tanstack/react-query';
import { API_CLIENT } from '../api-new';

export const useAlarms = () => {
  return useQuery({
    queryKey: ['alarms'],
    queryFn: () => API_CLIENT.list_alarms(),
  });
};
